"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCssUtil = void 0;
const theme_1 = require("./theme");
class IkeCssUtil {
    static absolute(top, left) {
        return { position: 'absolute', top: theme_1.DefaultTheme.space(top), left: theme_1.DefaultTheme.space(left) };
    }
    static padding(up, right, down, left) {
        if (right == null) {
            return { padding: theme_1.DefaultTheme.space(up) };
        }
        if (down == null) {
            return { padding: `${theme_1.DefaultTheme.space(up)} ${theme_1.DefaultTheme.space(right)}` };
        }
        return { padding: `${theme_1.DefaultTheme.space(up)} ${theme_1.DefaultTheme.space(right)} ${theme_1.DefaultTheme.space(down)} ${theme_1.DefaultTheme.space(left)}` };
    }
}
exports.IkeCssUtil = IkeCssUtil;
IkeCssUtil.Font = {
    familyCondensed: {
        'font-family': theme_1.DefaultTheme.font.familyCondensed
    }
};
IkeCssUtil.Flex = {
    column: {
        display: 'flex',
        'flex-direction': 'column'
    },
    center: {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center'
    },
    centerVertical: {
        display: 'flex',
        'align-items': 'center'
    }
};
//# sourceMappingURL=theme.util.js.map